import { setCommonFilterToInitalState } from '@/app/globalRedux/filter/commonFilter'
import { setCompanyFiltersToInitialState } from '@/app/globalRedux/filter/companyFilter'
import { clearFilters } from '@/app/globalRedux/filter/newsFilter'
import { setProductFiltersToInitialState } from '@/app/globalRedux/filter/productFilter'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'
import { useTranslation } from '@/app/i18n/client'
import { useDispatch } from 'react-redux'

const ClearAllFilter = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const goToPage = usePageNumberUpdator()

  const cleatFilters = () => {
    dispatch(clearFilters())
    dispatch(setCompanyFiltersToInitialState())
    dispatch(setProductFiltersToInitialState())
    dispatch(setCommonFilterToInitalState())
    goToPage({ newPageNo: 1 })
  }
  return (
    <>
      <span className="text-[18px] font-ns_semibold text-left">
        {t('Filters')}
      </span>

      <span
        className="text-primary ml-auto flex text-[12px] items-center font-ns_bold cursor-pointer"
        onClick={() => {
          cleatFilters()
        }}
      >
        {t('Clear All')}
      </span>
    </>
  )
}

export default ClearAllFilter
